import { ButtonEvent } from "slotworks/graphics/elements/button-element";
import FlexiButton from "slotworks/graphics/elements/flexi-button";
import Layers from "slotworks/graphics/layers/layers";

export default class NotificationPopup {
    private static BUTTON_CLOSE: string = "btn-close";
    
    private closeButton: FlexiButton;
    
    constructor() {
        this.close = this.close.bind(this);
    }

    private setupListeners() {
        this.closeButton = Layers.PromoPopups.getFlexiButton(NotificationPopup.BUTTON_CLOSE);
        this.closeButton.setEnabled(true);
        this.closeButton.on(ButtonEvent.POINTER_UP,this.close);
    }

    public show() {
        Layers.PromoPopups.setScene("promonotification").execute();
        this.setupListeners();
        Layers.PromoPopups.show();
    }

    public close() {
        this.hide();
    }
    
    public hide() {
        this.closeButton.off(ButtonEvent.POINTER_UP,this.close);
        this.closeButton.setEnabled(false);
        Layers.PromoPopups.hide();
    }
}